export default {

  mounted() {
    this.disableForceTouch()
  },

  methods: {
    disableForceTouch() {
      if(typeof this.$el.querySelectorAll == 'function') {
        _.each(this.$el.querySelectorAll('.disable-force-touch'), el => {
          el.addEventListener('touchforcechange', e => {
            if(e.changedTouches[0].force > 0.5) {
              e.preventDefault()
              return false
            }
          })
        })
      }
    },
  },

	data: () => ({
    tracking: {
      show: {
        "showName": "Alegria",
        "showCity": "montreal",
        "showYear": "2019",
        "showCountry": "CAN",
        "showType": "Big Top",
        "businessUnit": "TSD"
      },
      page: {
        "contentName": "",
        "device": "mobile",
        "environment": "CDS.com",
        "gaStep": "",
        "language": "",
        "pageType": "AlegriaAR",
        "requestURI": "",
        "standardRequestURI": ""
      }
    }
	}),

  created() {
    this.tracking.page.language = this.lang
    this.tracking.page.requestURI = window.location.pathname + '?ga_step='
    this.tracking.page.standardRequestURI = window.location.href
  },

}
